import { DateTimeMode } from '@/utils/query-filters';
import {
    DEFAULT_DRAFT_FILTERS,
    type QueryPanelDraft,
} from '@/stores/query-panel.store';

export function useQueryFilters(draft: QueryPanelDraft) {
    const handleDateTimeFilterApply = (range: {
        startTime: Date;
        endTime: Date;
        mode: DateTimeMode;
    }) => {
        draft.setDateTimeFilter(range.mode, {
            startDate: range.startTime,
            endDate: range.endTime,
        });
    };

    const resetDateTimeFilter = () => {
        const defaultDateTime = DEFAULT_DRAFT_FILTERS.dateTime;
        draft.setDateTimeFilter(
            defaultDateTime.mode,
            defaultDateTime.customRange,
        );
    };

    const handleConfidenceFilterApply = (range: {
        min: number;
        max: number;
    }) => {
        draft.setConfidenceFilter(true, range.min, range.max);
    };

    const handleObjectTypeFilterApply = (classIds: Set<number>) => {
        draft.setObjectClassSelection(classIds);
    };

    const handleObjectTypeFilterClear = () => {
        draft.clearObjectClassSelection();
    };

    const handleSceneOnlyChange = (enabled: boolean) => {
        draft.setSceneOnly(enabled);
    };

    return {
        filters: draft.draftFilters,
        selectedObjectClassIds: draft.draftObjectClassIds,
        handleDateTimeFilterApply,
        resetDateTimeFilter,
        handleConfidenceFilterApply,
        handleObjectTypeFilterApply,
        handleObjectTypeFilterClear,
        handleSceneOnlyChange,
    };
}
